import { useTranslation } from 'react-i18next'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { AcknowledgeModal, ConfirmationModal, Modal } from '@percent/lemonade'
import { useMutation } from '@percent/utility'
import { UpdateStatusModalProps } from './modals.types'

export function UpdateStatusModal({ refreshPrograms, program, isModalOpen, setIsModalOpen }: UpdateStatusModalProps) {
  const { t } = useTranslation()
  const { validationSubmissionsService } = useServices()

  const newProgramStatus = !program.deprecatedAt
  const newProgramStatusName = program.deprecatedAt ? 'Active' : 'Deprecated'

  const [{ isPending: isUpdatingStatus, status }, { apiFunc: updateValidationSubmissionStatus }] = useMutation(
    validationSubmissionsService.updateValidationSubmissionConfigurationStatus,
    undefined,
    undefined,
    { mutationKey: ['update-program-status', program.id] }
  )

  const isStatusSuccess = status === 'success'
  const isStatusError = status === 'error'

  const handleCloseStatusModal = () => setIsModalOpen(false)

  const handleCloseAndRefresh = () => {
    handleCloseStatusModal()
    refreshPrograms()
  }

  const statusSuccessModal = isStatusSuccess && (
    <AcknowledgeModal
      result="positive"
      title={t(`dialog.markProgramAs${newProgramStatusName}.success.title`)}
      description={t(`dialog.markProgramAs${newProgramStatusName}.success.description`, {
        programName: program.name || t('typography.unnamedProgram')
      })}
      buttonText={t('button.close')}
      handleClose={handleCloseAndRefresh}
    />
  )

  const statusErrorModal = isStatusError && (
    <AcknowledgeModal
      result="negative"
      title={t(`dialog.markProgramAs${newProgramStatusName}.error.title`)}
      description={t(`dialog.markProgramAs${newProgramStatusName}.error.description`)}
      buttonText={t('button.done')}
      handleClose={handleCloseAndRefresh}
    />
  )

  const statusConfirmationModal = !isStatusSuccess && !isStatusError && (
    <ConfirmationModal
      title={t(`dialog.markProgramAs${newProgramStatusName}.title`)}
      primaryButtonText={t(`button.markAs${newProgramStatusName}`)}
      primaryBtnTestId="mark-program-status"
      secondaryButtonText={t('button.cancel')}
      loading={isUpdatingStatus}
      handleSubmit={() => {
        updateValidationSubmissionStatus({
          id: program.id,
          deprecated: newProgramStatus
        })
      }}
      handleClose={handleCloseStatusModal}
    >
      {t(`dialog.markProgramAs${newProgramStatusName}.description`)}
    </ConfirmationModal>
  )

  return (
    <Modal open={isModalOpen} onClose={handleCloseStatusModal}>
      {statusSuccessModal || statusErrorModal || statusConfirmationModal}
    </Modal>
  )
}
